import { AGENT_SCREEN_FIELD } from '../agents/AgentConstants';

export const AGENT_VOIP_MODE_FIELD = 'voipMode';
export const AGENT_VOIP_CONFIGURATION = 'voipConfiguration';
export const AGENT_VOIP_CONFIGURATION_REGISTRATION = `${AGENT_VOIP_CONFIGURATION}.registration`;
export const AGENT_VOIP_CONFIGURATION_REGISTRATION_STATUS_FIELD = `${AGENT_VOIP_CONFIGURATION_REGISTRATION}.status`;
export const AGENT_VOIP_CONFIGURATION_REGISTRATION_UPDATED_AT_FIELD = `${AGENT_VOIP_CONFIGURATION_REGISTRATION}.updatedAt`;
export const AGENT_VOIP_CONFIGURATION_REGISTRATION_ERROR = `${AGENT_VOIP_CONFIGURATION_REGISTRATION}.error`;
export const AGENT_VOIP_CONFIGURATION_REGISTRATION_SIGNALING_COLLECTION_FIELD = `${AGENT_VOIP_CONFIGURATION_REGISTRATION_ERROR}.signaling_collection`;
export const AGENT_VOIP_CONFIGURATION_ADAPTER_TYPE_FIELD = `${AGENT_VOIP_CONFIGURATION}.adapterType`;

// Screen fields derived
export const AGENT_VOIP_REGISTRATION_DETAIL = `${AGENT_SCREEN_FIELD}.registrationDetail`;
export const AGENT_VOIP_REGISTRATION_DETAIL_HAS_INFO = `${AGENT_VOIP_REGISTRATION_DETAIL}.hasRegistrationInfo`;
export const AGENT_VOIP_REGISTRATION_DETAIL_IS_REGISTERED = `${AGENT_VOIP_REGISTRATION_DETAIL}.isRegistered`;
export const AGENT_VOIP_REGISTRATION_DETAIL_NO_REGISTRATION_MESSAGE = `${AGENT_VOIP_REGISTRATION_DETAIL}.noVoIPRegistrationMessage`;
export const AGENT_VOIP_REGISTRATION_DETAIL_REGISTRATION_STATUS = `${AGENT_VOIP_REGISTRATION_DETAIL}.registrationStatus`;
export const AGENT_VOIP_REGISTRATION_DETAIL_HAS_REGISTRATION_STATUS = `${AGENT_VOIP_REGISTRATION_DETAIL}.hasRegistrationStatus`;
export const AGENT_VOIP_REGISTRATION_DETAIL_LAST_REGISTERED = `${AGENT_VOIP_REGISTRATION_DETAIL}.registrationLastDttm`;
export const AGENT_VOIP_REGISTRATION_DETAIL_REGISTRATION_ERROR_OBJECT = `${AGENT_VOIP_REGISTRATION_DETAIL}.registrationErrorObject`;

export const VOIP_MODE_NONE = 'N';
export const VOIP_MODE_PRE_PROVISIONED = 'P';
export const VOIP_MODE_PRE_MANUAL = 'M';
export const VOIP_MODE_PRE_AUTO = 'A';

export const VOIP_REGISTRATION_STATUS_PENDING = `Pending`;
export const VOIP_REGISTRATION_STATUS_ERROR = `Registration Error`;
export const VOIP_REGISTRATION_STATUS_REGISTERED = `Registered`;
export const VOIP_REGISTRATION_STATUS_DIRECT_CALLING = `Direct Calling`;
export const VOIP_REGISTRATION_STATUS_DIRECT_CALLING_NOT_READY = `Initialization Error`;
